const compact = (value) => String(value == null ? '' : value)
  .trim()
  .replace(/[\s_-]+/g, '')
  .toUpperCase();

export const isSealedCatalogItem = (item) => {
  // Catalogue classification wins over client discriminators. Explicit
  // non-catalogue types are compatibility fallbacks only without sealed data.
  if (item?.isSealed === true || item?.isSingle === false) return true;
  return (
    !(
    item?.isCustom === true || item?.isCustomItem === true || item?.isVideoGame === true ||
    item?.isGraded === true || ['custom-item', 'graded-card', 'video-game', 'shop-product']
      .includes(String(item?.itemType || '').toLowerCase())
    ) && item?.itemType === 'sealed-product'
  );
};

const isUnopenedSku = (sku) => [
  sku?.condAbbr, sku?.conditionAbbreviation, sku?.condName, sku?.condition
].some((value) => ['U', 'UNOPENED'].includes(compact(value)));

export const resolveUniqueUnopenedSku = (item) => {
  if (!isSealedCatalogItem(item)) return { sealed: false, sku: null, error: null };
  const unique = new Map();
  for (const sku of Array.isArray(item?.skus) ? item.skus : []) {
    if (sku?.skuId == null || sku?.skuId === '' || !isUnopenedSku(sku)) continue;
    unique.set(String(sku.skuId), sku);
  }
  if (unique.size === 0) return {
    sealed: true, sku: null,
    error: `${item?.name || 'This sealed product'} has no verifiable unopened catalogue SKU.`
  };
  if (unique.size > 1) return {
    sealed: true, sku: null,
    error: `${item?.name || 'This sealed product'} has multiple unopened catalogue SKUs.`
  };
  return { sealed: true, sku: [...unique.values()][0], error: null };
};

export const sealedSelection = (item) => {
  const resolution = resolveUniqueUnopenedSku(item);
  if (!resolution.sealed || resolution.error) return resolution;
  const sku = resolution.sku;
  return {
    ...resolution,
    condition: sku.condAbbr || sku.conditionAbbreviation || sku.condName || 'U',
    printing: sku.printingName || sku.printing || 'Normal',
    language: sku.langAbbr || sku.languageAbbreviation || sku.languageName || 'EN',
    skuId: sku.skuId
  };
};

export const canonicalizeSealedCartItem = (item) => {
  const selection = sealedSelection(item);
  if (!selection.sealed) {
    if (item?.isSingle !== true) return { item, error: null };
    const normalized = {
      ...item,
      isSealed: false,
      isSingle: true,
      isCustom: false,
      isCustomItem: false,
      isVideoGame: false,
      isGraded: false
    };
    if (
      item?.isCustom === true || item?.isCustomItem === true || item?.isVideoGame === true ||
      item?.isGraded === true || ['custom-item', 'graded-card', 'video-game', 'shop-product', 'sealed-product']
        .includes(String(item?.itemType || '').toLowerCase())
    ) delete normalized.itemType;
    return { item: normalized, error: null };
  }
  if (selection.error) return { item, error: selection.error };
  return {
    item: {
      ...item,
      productId: Number(item.productId),
      skuId: selection.skuId,
      condition: selection.condition,
      printing: selection.printing,
      printType: selection.printing,
      language: selection.language,
      itemType: 'sealed-product',
      isSealed: true,
      isSingle: false,
      isCustom: false,
      isCustomItem: false,
      isVideoGame: false,
      isGraded: false
    },
    error: null
  };
};
